import React from "react";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { queryKey } from "@/store/queryKeys.ts";
import { constants } from "@/constants";
import {
  Table,
  TableBody,
  TableCaption,
  TableCell,
  TableFooter,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/shadcn/table.tsx";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/shadcn/card.tsx";

export const PaymentList: React.FC = () => {
  const { t } = useTranslation();

  let paymentsQuery = useQuery(queryKey.payments, async function () {
    let res = await fetch(`${constants.url.API_PREFIX}billing/payments`);
    return res.json();
  });

  if (paymentsQuery.isLoading || !paymentsQuery.data?.length) {
    return null;
  }

  return (
    <Card className="">
      <CardHeader className="relative">
        <CardTitle>{t("billing.transactions")}</CardTitle>
        <CardDescription></CardDescription>
      </CardHeader>
      <CardContent>
        <Table>
          <TableCaption></TableCaption>
          <TableHeader>
            <TableRow>
              <TableHead>{t("billing.date")}</TableHead>
              <TableHead>{t("billing.payment_method")}</TableHead>
              <TableHead>{t("billing.amount")}</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {paymentsQuery.data.map((row: any, i: number) => (
              <TableRow key={i}>
                <TableCell className="font-medium">
                  {new Date(row.created_at * 1000).toLocaleString()}
                </TableCell>
                <TableCell className="font-medium">
                  {row.payment_method.toUpperCase()}
                </TableCell>
                <TableCell className="font-medium">
                  {row.amount}&nbsp;
                  {row.currency}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
          <TableFooter></TableFooter>
        </Table>
      </CardContent>
      <CardFooter className="flex justify-between"></CardFooter>
    </Card>
  );
};
